import {
  AutocompleteInput,
  BooleanInput,
  ReferenceInput,
  TextInput,
} from "react-admin";
import MuiDatePickerInput from "../../common/MuiDatePickerInput";

const allTransactionJournalFilterList = (permissions, options = {}) => {
  const { includeCompany = true } = options;
  const defaultFilter = [
    <TextInput
      alwaysOn
      source="code"
      resettable
      variant="outlined"
      label="mine.label.receipt_no"
    />,
    <MuiDatePickerInput
      alwaysOn
      source="start_date"
      variant="outlined"
      label="mine.label.start_date"
      maxDateSource="end_date"
    />,
    <MuiDatePickerInput
      alwaysOn
      source="end_date"
      //FIXME: semua DateInput tidak bisa di tambah resettable
      // resettable
      variant="outlined"
      label="mine.label.end_date"
      minDateSource="start_date"
    />,
    <TextInput
      alwaysOn
      source="cus_sup"
      resettable
      variant="outlined"
      label="mine.label.cus_sup"
    />,
    <BooleanInput alwaysOn source="is_balance" label="mine.label.balance" />,
  ];
  if (
    includeCompany &&
    permissions &&
    (permissions.update_company || permissions.administrator || permissions.superadmin)
  ) {
    defaultFilter.splice(
      1,
      0,
      <ReferenceInput
        alwaysOn
        source="company_id"
        reference="companies"
        sort={{ field: "companies.alias", order: "ASC" }}
      >
        <AutocompleteInput
          resettable
          optionText="alias"
          variant="outlined"
          label="mine.label.company"
        />
      </ReferenceInput>
    );
  }
  return defaultFilter;
};

export default allTransactionJournalFilterList;
